// @flow

import _ from "lodash";
import URL from "domurl";
import React, { Component } from "react";
import mercury from "mercury-parser";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";

import WebPage from "./WebPage";
import SearchBox from "./SearchBox";
import SearchResults from "./SearchResults";
import Pagination from "./Pagination";
import * as constants from "./constants";
import ReactGA from "react-ga";

import "react-tabs/style/react-tabs.css";
import "./Google.css";

// TODO - add other mercury reader response fields
type WebPageContent = {
  link: string,
  title: string,
  contentHTML: string
};

type State = {
  tabIndex: number,
  query: string,
  searchResults: Array<Object>,
  currentWebPage: WebPageContent,
  nextIndex: ?number,
  prevIndex: ?number,
  searchIsLoading: boolean,
  resultIsLoading: boolean,
  googleDown: boolean,
  mercuryDown: boolean
};

type Props = {
  search: string => void
};

class Google extends Component<Props, State> {
  mercuryAPI: any; // TODO fix

  constructor(props: Props) {
    super(props);
    this.state = {
      query: "",
      searchResults: [],
      currentWebPage: { link: "", title: "", contentHTML: "" },
      prevIndex: null,
      nextIndex: null,
      tabIndex: 0,
      resultIsLoading: false,
      searchIsLoading: false,
      mercuryDown: false,
      googleDown: false
    };
    this.mercuryAPI = mercury(constants.MERCURY_API_KEY);
  }

  search = (q: string, index: ?number) => {
    if (!q) {
      return;
    }
    this.setState({
      searchIsLoading: true,
      searchResults: []
    });

    // TODO - just use the google node API wrapper
    const searchURL: URL = new URL(constants.CSE_URL);
    _.assign(searchURL.query, {
      q,
      start: index ? index : null
    });

    this.props.search(q);

    fetch(searchURL)
      .then(response => {
        if (response.status >= 200 && response.status < 300) {
          return response.json();
        } else {
          throw new Error(
            `GoogleCustomSearch: Received status ${response.status}` // TODO - parse Google's error response format
          );
        }
      })
      .then(json => {
        this.setState({ searchIsLoading: false, googleDown: false });
        this.handleSearchResponse(json);
      })
      .catch(err => {
        console.error("Error retrieving search results", err);
        this.setState({ searchIsLoading: false, googleDown: true });
        throw err; // Rethrow so that we see error in Sentry
      });

    this.setState({ query: q });
  };

  handleSearchResponse = (response: Object) => {
    console.log("handleSearchResponse: response: ", response);
    let prevIndex, nextIndex;
    if (response.queries) {
      if (response.queries.previousPage) {
        prevIndex = response.queries.previousPage[0].startIndex;
      }
      if (response.queries.nextPage) {
        nextIndex = response.queries.nextPage[0].startIndex;
      }
    }
    this.setState({
      searchResults: response.items,
      prevIndex,
      nextIndex
    });
  };

  handleSearchResultClick = (link: string) => {
    this.setState({
      resultIsLoading: true,
      tabIndex: 1
    });
    ReactGA.event({ category: "Task", action: "Click Link", label: link });

    // Use the Mercury Web Parser API to get a readable version of the article content
    this.mercuryAPI
      .parse(link)
      .then(response => {
        if (response.error === true) {
          console.log(response);
          throw new Error(`Mercury: received error ${response.error}`);
        } else {
          const currentWebPage = {
            link,
            title: response.title,
            contentHTML: response.content
          };
          this.setState({
            currentWebPage,
            resultIsLoading: false,
            mercuryDown: false
          });
        }
      })
      .catch(err => {
        this.setState({ resultIsLoading: false, mercuryDown: true });
        console.error("error summarizing search results", err);
        throw err; // Rethrow so that we see error in Sentry
      });
  };

  render() {
    const resultsAvailable =
      this.state.searchResults && this.state.searchResults.length > 0;
    return (
      <div className="Google">
        <Tabs
          forceRenderTabPanel
          selectedIndex={this.state.tabIndex}
          onSelect={tabIndex => this.setState({ tabIndex })}
        >
          <TabList>
            <Tab>Google</Tab>
            <Tab>Browse</Tab>
          </TabList>

          <TabPanel>
            {this.state.googleDown
              ? "Google search not available, please try again later."
              : null}
            <SearchBox search={this.search} />
            {this.state.searchIsLoading ? "Loading search results..." : null}
            {resultsAvailable ? (
              <div>
                <SearchResults
                  results={this.state.searchResults}
                  handleClick={this.handleSearchResultClick}
                  nextIndex={this.state.nextIndex}
                  prevIndex={this.state.prevIndex}
                />
                <Pagination
                  handlePrev={() =>
                    this.search(this.state.query, this.state.prevIndex)
                  }
                  handleNext={() =>
                    this.search(this.state.query, this.state.nextIndex)
                  }
                />
              </div>
            ) : null}
          </TabPanel>

          <TabPanel>
            {this.state.mercuryDown
              ? "Page summaries not available, please try again later."
              : null}
            {this.state.resultIsLoading ? (
              "Loading web page..."
            ) : (
              <WebPage
                title={this.state.currentWebPage.title}
                contentHTML={this.state.currentWebPage.contentHTML}
              />
            )}
          </TabPanel>
        </Tabs>
      </div>
    );
  }
}

export default Google;



// WEBPACK FOOTER //
// ./src/components/Google/Google.js